/* eslint-disable max-len */
import 'react';

const CommentNumberSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h16v16H0z" />
            <path
                d="M2.33 2h11.612a.83.83 0 01.829.83v8.948a.83.83 0 01-.83.83h-7.79c-.683 0-1.357.164-1.964.48L1.5 14.49h0V2.83A.83.83 0 012.33 2z"
                stroke="#C7CDD9"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <rect fill="#C7CDD9" x="7.306" y="8.221" width="4.562" height="1.5" rx=".531" />
        </g>
    </svg>
);
export default CommentNumberSvg;
